import React, { useMemo } from 'react';
import IntlTelInput from '@intl-tel-input/react';
import 'intl-tel-input/styles';

/**
 * Country-code phone input powered by intl-tel-input
 * https://github.com/jackocnr/intl-tel-input
 *
 * Defaults to Tanzania (+255). Booking/payment use Tanzania-only.
 * Emits E.164 via onChangeE164.
 */
export default function IntlPhoneField({
  value = '',
  onChangeE164,
  onChangeValidity,
  initialCountry = 'tz',
  /** When true, only Tanzania is selectable (use on payment / mobile-money). */
  tanzaniaOnly = false,
  preferredCountries = ['tz', 'ke', 'ug', 'rw', 'bi'],
  placeholder,
  disabled = false,
  className = '',
  inputClassName = '',
  autoComplete = 'tel',
  name,
  id,
  required = false,
}) {
  const initOpts = useMemo(
    () => ({
      initialCountry: tanzaniaOnly ? 'tz' : initialCountry,
      ...(tanzaniaOnly
        ? { onlyCountries: ['tz'] }
        : { preferredCountries, countryOrder: preferredCountries }),
      nationalMode: false,
      formatAsYouType: true,
      formatOnDisplay: true,
      strictMode: true,
      loadUtils: () => import('intl-tel-input/utils'),
    }),
    [initialCountry, preferredCountries, tanzaniaOnly]
  );

  return (
    <div className={`intl-phone-field w-full ${className}`.trim()}>
      <IntlTelInput
        {...initOpts}
        value={value || null}
        disabled={disabled}
        onChangeNumber={(number) => {
          if (onChangeE164) onChangeE164(number || '');
        }}
        onChangeValidity={(isValid) => {
          if (onChangeValidity) onChangeValidity(Boolean(isValid));
        }}
        inputProps={{
          name,
          id,
          required,
          autoComplete,
          placeholder: placeholder || '07XXXXXXXX',
          className:
            inputClassName ||
            'w-full rounded-lg border border-pink-200 bg-white px-3 py-2.5 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-superfeo-pink/30 focus:border-superfeo-pink',
        }}
      />
    </div>
  );
}
